/* global FB */
import addClickTrackingHandler from './utils/addClickTrackingHandler';
import debounce from './utils/debounce';
import events from './utils/events';
import facebookSignIn from './utils/facebook/facebookSignIn';
import framePage from './utils/framePage';
import redirectIfNotInFrame from './utils/redirectIfNotInFrame';
import sendMessageToParent from './utils/sendMessageToParent';
import submitForm from './index/submitForm';
import validatorFields from './index/validation/validatorFields';

($ => {
	$(() => {
		redirectIfNotInFrame();
		addClickTrackingHandler();
		sendMessageToParent(events.SIGNIN_START);
		let height = $('body').height();
		sendMessageToParent('FRAME_RESIZE', { height });
		const sendHeightToParent = debounce(() => {
			const newHeight = $('body').height();
			if (newHeight !== height) {
				height = newHeight;
				sendMessageToParent('FRAME_RESIZE', { height });
			}
		}, 20);

		framePage.$fbSignInBtn = $('#fbSignInBtn');
		framePage.$password = $('#password');
		framePage.$signInBtn = $('#signInBtn');
		framePage.$title = $('#title');
		framePage.$username = $('#username');

		$.ajaxSetup({ cache: true });

		$.getScript('//connect.facebook.net/en_US/sdk.js', () => {
			const fbInitOptions = {
				appId: framePage.$fbSignInBtn.data('fbAppId'),
				cookie: true, // enable cookies to allow the server to access the session
				xfbml: true, // parse social plugins on this page
				version: framePage.$fbSignInBtn.data('fbGraphApiVersion')
			};
			FB.init(fbInitOptions);

			framePage.$fbSignInBtn.on('click', () => {
				framePage.$fbSignInBtn.addClass('loading');
				facebookSignIn(framePage.$fbSignInBtn.data('fbPermissions'));
			});
		});

		const $signInForm = $('#signInForm');

		$signInForm.validator({
			allowMultipleSubmissions: true,
			fields: validatorFields,
			onSubmit: submitForm
		});

		$signInForm.removeAttr('onsubmit');
		framePage.$username.focus();

		const heightObserver = new MutationObserver(sendHeightToParent);
		heightObserver.observe(document.body, { attributes: true, childList: true, subtree: true });

		window.addEventListener('resize', sendHeightToParent);
	});
})(jQuery);



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/index.js